import styled from 'styled-components';

export const PageContainer = styled.div`
	min-height: 100dvh;
	display: grid;
	place-items: center;
	padding: 24px;
`;

export const StyledCard = styled.div`
	max-width: 768px;
	width: 100%;
	padding: 32px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
	border-radius: 16px;
	background: #fff;
`;

export const Title = styled.div`
	text-align: center;
	margin-bottom: 24px;
`;
